export default __webpack_public_path__ + "static/media/shield.69b89316.svg";